export function isArray(o: any): o is Array<any> {
  if (o === null || o === undefined) {
    return false;
  }
  if (typeof o !== "object") {
    return false;
  }
  if (typeof o.length !== "number") {
    return false;
  }
  if (Object.keys(o).length !== 0) {
    return false;
  }
  return true;
}
